module.exports = __webpack_public_path__ + "img/certificate1-01.f4c9be17.png";